const facebookAppId = process.env.MIX_FB_APP_ID;

export function initFacebookSdk() {
	return new Promise((resolve) => {
		if (window.FB) {
			return resolve();
		}

		window.fbAsyncInit = function () {
			FB.init({
				appId: facebookAppId,
				cookie: true,
				xfbml: true,
				version: 'v17.0',
			});

			resolve();
		};

		// load facebook sdk script
		(function (d, s, id) {
			var js,
				fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) {
				return;
			}
			js = d.createElement(s);
			js.id = id;
			js.src = 'https://connect.facebook.net/en_US/sdk.js';
			fjs.parentNode.insertBefore(js, fjs);
		})(document, 'script', 'facebook-jssdk');
	});
}

export const login = () => {
	return new Promise((resolve) => {
		FB.login(
			(response) => {
				resolve(response.authResponse);
			},
			{
				config_id: process.env.MIX_FB_CONFIGURATION_ID,
				response_type: 'code',
				override_default_response_type: true,
				extras: {
					sessionInfoVersion: 2,
				},
			},
		);
	});
};
